import React from 'react'
import DocumentList from './components/DocumentList'
import UploadForm from './components/UploadForm'
import MDBox from 'components/MDBox'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
function DocumentUpload() {
  return (
     <DashboardLayout>
      <DashboardNavbar />
    <MDBox sx={{backgroundColor: '#fff', Padding:"2rem"}}>
      <UploadForm/>
      <DocumentList/>
    </MDBox>
    </DashboardLayout>
  )
}

export default DocumentUpload
